'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMerchandiseMap = getMerchandiseMap;
exports.contactsQuantityMultiplier = contactsQuantityMultiplier;
exports.maxAdditionalUnits = maxAdditionalUnits;
exports.includedAdditionalUnits = includedAdditionalUnits;
exports.billingNameKey = billingNameKey;
exports.merchandiseEdition = merchandiseEdition;
exports.minPurchasableContacts = minPurchasableContacts;

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getMerchandiseMap(merchandiseId) {
  return _ImmutableMerchandiseIdMap2.default[merchandiseId];
}

function contactsQuantityMultiplier(merchandiseId) {
  var additionalUnitMerchId = _ImmutableMerchandiseIdMap2.default[merchandiseId].additionalUnitMerchId;

  return _ImmutableMerchandiseIdMap2.default[additionalUnitMerchId].quantityMultiplier;
}

function maxAdditionalUnits(merchandiseId) {
  return _ImmutableMerchandiseIdMap2.default[merchandiseId].maxAdditionalUnits;
}

function includedAdditionalUnits(merchandiseId) {
  return _ImmutableMerchandiseIdMap2.default[merchandiseId].includedAdditionalUnits;
}

function billingNameKey(merchandiseId) {
  return _ImmutableMerchandiseIdMap2.default[merchandiseId].billingNameKey;
}

function merchandiseEdition(merchandiseId) {
  return _ImmutableMerchandiseIdMap2.default[merchandiseId].edition;
}

function minPurchasableContacts(_ref) {
  var merchandiseId = _ref.merchandiseId,
      numContactsInCrm = _ref.numContactsInCrm,
      multiplier = _ref.multiplier,
      purchasedContacts = _ref.purchasedContacts;

  if (!purchasedContacts) {
    if (numContactsInCrm < includedAdditionalUnits(merchandiseId)) return includedAdditionalUnits(merchandiseId);
    if (numContactsInCrm <= multiplier) return contactsQuantityMultiplier(merchandiseId);
  }

  var purchasableContactsFromCrm = Math.ceil(numContactsInCrm / multiplier) * multiplier;

  return Math.max(purchasableContactsFromCrm, purchasedContacts);
}


//////////////////
// WEBPACK FOOTER
// ./js/utils/merchandiseUtils.js
// module id = 83
// module chunks = 3 4 5